import { LogoutOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Flex, Layout, MenuProps, Space, Tag } from 'antd';
import React from 'react';
import { useAppContext } from '../../context/appContext';
import useAuthService from '../../hooks/useAuthService';
const { Header: AntdHeader } = Layout;

const items: MenuProps['items'] = [
  {
    label: 'Cerrar sesion',
    key: '1',
    icon: <LogoutOutlined />,
  },
];

const Header = () => {
  const {
    settings: { issuer },
  } = useAppContext();
  const { userInfo, logOut } = useAuthService();

  const handleOnLogOutClick = () => {
    logOut();
  };

  const menuProps = {
    items,
    onClick: handleOnLogOutClick,
  };

  return (
    <AntdHeader style={{ background: 'rgb(243, 245, 248)' }}>
      <Flex justify="flex-end">
        <Space align="center">
          <Tag color="purple">{issuer?.name}</Tag>
          <Dropdown menu={menuProps}>
            <Button type="text" style={{ height: 'auto' }}>
              <Space align="center">
                <Avatar size="small">{userInfo.name.charAt(0).toUpperCase()}</Avatar>
                {userInfo.name}
              </Space>
            </Button>
          </Dropdown>
        </Space>
      </Flex>
    </AntdHeader>
  );
};

export default Header;
